export const statusList = [
  {
    label: 'Belum Dipacking',
    value: 'submitted',
  },
  {
    label: 'Dipacking',
    value: 'confirmed',
  },
  {
    label: 'Terkirim',
    value: 'shipped',
  },
  {
    label: 'Dibatalkan',
    value: 'canceled',
  },
]

export const statusMapping = {
  unknown: {
    label: 'Unknown',
    color: {
      main: '#000000',
      sub: '#E2E2E2',
    },
  },
  'Belum Dipacking': {
    label: 'Belum Dipacking',
    color: {
      main: '#3B82F6',
      sub: '#EFF6FF',
    },
  },
  Dipacking: {
    label: 'Dipacking',
    color: {
      main: '#F95E16',
      sub: '#FFE8D9',
    },
  },
  'Menunggu Pickup': {
    label: 'Menunggu Pickup',
    color: {
      main: '#FBBC05',
      sub: '#FEF2CD',
    },
  },
  Dikirim: {
    label: 'Terkirim',
    color: {
      main: '#34A770',
      sub: '#DCF3EB',
    },
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: {
      main: '#DC2626',
      sub: '#FEF2F2',
    },
  },
}

const defaultThClass = 'align-middle text-capitalize font-medium text-[#333333] !text-[14px]'
const defaultTdClass = 'align-middle text-capitalize text-[#333333] !text-[14px]'

export const fieldsOutboundNonKomship = [
  {
    key: 'id',
    label: 'Outbond ID',
  },
  {
    key: 'submit_date',
    label: 'Tanggal Order',
  },
  {
    key: 'partner_name',
    label: 'Partner',
  },
  {
    key: 'total_products',
    label: 'Jumlah Item',
  },
  {
    key: 'total_orders',
    label: 'Jumlah Order',
  },
  {
    key: 'status',
    label: 'Status Packing',
  },
  {
    key: 'rincian',
    label: 'Rincian',
  },
]

export const fieldsOutboundNonKomshipConfirmed = [
  ...fieldsOutboundNonKomship,
]

export const MODAL_TYPE_ICON = {
  WARNING: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
  SUCCESS: 'https://storage.googleapis.com/komerce/assets/icons/success.svg',
}
